import http from '../../utils/httpService';
import { LOGIN_ROUTE } from './constants';

/**
 *
 * @param form
 */
export const requestToken = form => {
    return http.request( LOGIN_ROUTE, 'POST', form );
};
